import {createProperty} from './utils/createProperty'

/**
 * The annotation builder for a component property with type 'Date'.
 */
export const date = createProperty('date').typed('date')
